export const APPCONFIG = {
  axiosBaseUrl: window.location.origin
}
